import classes from '@/components/Shares/Table.module.css';
import { useLingui } from '@lingui/react';
import { Avatar, Group, NumberFormatter, Table, Text } from '@mantine/core';
import { referrals } from './referrals';
export const ReferralTable: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const rows = referrals.map(row => <Table.Tr key={row.username}>
      <Table.Td h={45} px={16}>
        <Group wrap="nowrap" gap={10}>
          <Avatar src={row.avatar} alt="coin" size={25} />
          <Text fz={{
          base: 'xs',
          md: 13
        }} fw={500} c="var(--text-dark)">
            {row.username}
          </Text>
        </Group>
      </Table.Td>
      <Table.Td h={45} px={16}>
        <Text fw={500} fz={{
        base: 'xs',
        md: 13
      }} c="var(--text-dark)" ta="right">
          <NumberFormatter suffix={i18n._(' Referrals')} value={row.ref} thousandSeparator="," decimalSeparator="." decimalScale={2} />
        </Text>
      </Table.Td>
    </Table.Tr>);
  const ths = <Table.Tr>
      <Table.Th>{''}</Table.Th>
      <Table.Th>{''}</Table.Th>
    </Table.Tr>;
  return <Table.ScrollContainer minWidth={300} mt={10}>
      <Table striped classNames={classes}>
        <Table.Thead>{ths}</Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </Table.ScrollContainer>;
};